<div id="app">
    <v-app>
        <v-main>
            <component :is="layout">
                <router-view />
            </component>
            <NotificationSnackbar />
        </v-main>
    </v-app>
</div>
